import { CustomModelAutomaticMutationSideEffectConfigs } from "../types";

export const PHONE_CALLS_MUTATION_SIDE_EFFECT_CONFIGS: CustomModelAutomaticMutationSideEffectConfigs<"phone_calls"> =
  {};
